import { useState, useEffect } from "react";
//API
import { axiosWithAuth } from "../../../../api/axiosConfig";
import {
  urlGetVehicleBrands,
  urlCreateVehicleBrand,
  urlEditVehicleBrand,
} from "../../../../api/URLs/entidadesSecundarias/marcas";
//HOOKS
import { useModal } from "../../../../hooks/useModal";
//FORMIK & YUP
import { Formik } from "formik";
import { brandsSchema } from "../../../../schemas/Camiones/EntidadesSecundarias/brandsSchema";
//BOOTSTRAP
import { Button, Form, FormGroup } from "react-bootstrap";
//COMPONENTS
//--Modal
import ModalAlert from "../../../../components/Modals/ModalAlert";
//--Table
import Table from "../../../../components/Tools/Tables/Table/Table";
//--Basic
import BoxContainer from "../../../../components/Tools/Cards/BoxContainer/BoxContainer";
import CenterSpinner from "../../../../components/Tools/Basics/Spinner";
import CustomBtn from "../../../../components/Tools/Basics/CustomBtn";

const FormBrands = () => {
  //useModal
  const {
    showModal,
    modalType,
    msjModal,
    handleClose,
    handleError,
    handleSucces,
  } = useModal();
  //States
  const [reForm, setReForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  //INITIAL VALUES
  let newValues, updateValues;
  if (brand) {
    updateValues = {
      marca: brand.marca ? brand.marca : "",
    };
  } else {
    newValues = {
      marca: "",
    };
  }
  const initialValues = brand ? updateValues : newValues;
  //GET
  const getBrands = async () => {
    setLoadingTable(true);
    try {
      const api_response = await axiosWithAuth.get(urlGetVehicleBrands);
      setBrands(api_response.data);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoadingTable(false);
    }
  };
  //POST - PUT
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      let api_response;
      if (!brand) {
        api_response = await axiosWithAuth.post(urlCreateVehicleBrand, values);
      } else {
        api_response = await axiosWithAuth.put(urlEditVehicleBrand, {
          ...values,
          id: brand.id,
        });
      }
      handleSucces(api_response);
      setReForm(!reForm);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setBrand(null);
      setLoading(false);
    }
  };
  //HANDLES
  const handleEdit = async (c) => {
    setBrand(c);
    setReForm(!reForm);
  };
  //BOTONES
  const actions = (c) => {
    return <CustomBtn type={"edit_table"} onClick={() => handleEdit(c)} />;
  };
  //COLUMNAS
  const columns = [
    { header: "Id", field: "id" },
    { header: "Marca", field: "marca" },
    { header: "Editar", body: actions },
  ];
  useEffect(() => {
    getBrands();
  }, [reForm]);
  return (
    <div className="row">
      <div className="col-md-8">
        <BoxContainer maxSize={"lg"} minSize={"lg"}>
          <Table
            data={brands}
            columns={columns}
            keyProp={"id"}
            title={"Marcas"}
            scrollSize={"lg"}
            textFilter
            loading={loadingTable}
          />
        </BoxContainer>
      </div>
      <div className="col-md-4">
        {!loading ? (
          <>
            <div
              className={`alert alert-${
                brand ? "success" : "primary"
              } w-100 mb-0`}
              role="alert"
            >
              {`${brand ? "Modificar" : "Agregar nueva"} Marca ${
                brand ? brand.marca : ""
              }`}
            </div>
            <Formik
              enableReinitialize
              validationSchema={brandsSchema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className="shadow-none mb-2">
                  {/* NOMBRE */}
                  <FormGroup>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingresar Marca"
                      name="marca"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.marca}
                      isInvalid={errors.marca && touched.marca && errors.marca}
                    />
                  </FormGroup>
                  <Button
                    variant={brand ? "success" : "primary"}
                    className="w-100 mt-3"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {brand ? "Modificar" : "Agregar"}
                  </Button>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <CenterSpinner />
        )}
      </div>
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
    </div>
  );
};

export default FormBrands;
